import { createAuthClient } from "better-auth/react";
import { jwtClient } from "better-auth/client/plugins";

/**
 * 클라이언트 인증 훅/메서드 (M1).
 * - authClient.signIn/signUp/signOut/useSession 등.
 * - jwtClient: authClient.token() 으로 소켓 접속용 owner JWT 획득(§4·§6).
 */
// baseURL 미지정 → 현재 오리진 사용(same-origin). localhost·LAN·도메인 모두 동작.
export const authClient = createAuthClient({
  plugins: [jwtClient()],
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;
